const {
	i18n: {
		__,
		sprintf
	},
	hooks: {
		addAction,
		addFilter,
		applyFilters
	},
	element: {
		RawHTML,
		useState,
	},
	components: {
		BaseControl,
		ExternalLink,
		Button,
		Spinner,
		Placeholder
	}
} = wp;

const { pickBy } = lodash;
let { fields } = wecodeartGoogleExtension;

// addAction('wecodeart.admin.licensePanel', 'wecodeart/wooReviews/admin/license', panelAction);
// function panelAction(props) {
//     console.log(props);
// }

addFilter('wecodeart.admin.extensions', 'wecodeart/google/admin/panel', optionsPanel);
function optionsPanel(panels) {
	return [...panels, {
		name: 'wca-google',
		title: __('Google Tools', 'wca-google'),
		render: (props) => <GoogleTools {...props} />
	}];
}

const GoogleTools = (props) => {

	const {
		isRequesting,
		createNotice,
		saveEntityRecord,
		wecodeartSettings,
	} = props;

	if (isRequesting || !wecodeartSettings) {
		return (
			<Placeholder {...{
				icon: <Spinner />,
				label: __('Loading', 'wca-google'),
				instructions: __('Please wait, loading settings...', 'wca-google')
			}} />
		);
	}

	fields = applyFilters('wecodeart.admin.extension.google.fields', fields, props);
	fields = fields.filter(({ id = '', label = '' }) => (id !== '' && label !== ''));

	const extensionOpts = fields.map(a => a.id);
	const apiOptions = pickBy(wecodeartSettings, (v, k) => extensionOpts.includes(k));

	const [loading, setLoading] = useState(null);
	const [formData, setFormData] = useState(apiOptions);

	const handleNotice = () => {
		setLoading(false);
		return createNotice('success', __('Google Tools options updated.', 'wca-google'));
	};

	return (
		<>
			<table className="wecodeart-table table table-bordered table-striped" style={{
				width: '100%',
			}}>
				<thead>
					<tr style={{ textAlign: 'left' }}>
						<th style={{ width: '15%' }}>{__('Service', 'wca-google')}</th>
						<th>{__('Code', 'wca-google')}</th>
						<th>{__('Actions', 'wca-google')}</th>
					</tr>
				</thead>
				<tbody>
					{fields.map(({ id, label, placeholder = '', externalUrl = '' }) => {
						return (
							<tr>
								<td style={{ width: '15%' }}><strong>{label}</strong></td>
								<td>
									<BaseControl className="wecodeart-button-field" {...{ id, key: id }}>
										<input
											type="text"
											value={formData[id]}
											onChange={({ target: { value } }) => setFormData({ ...formData, [id]: value })}
											{...{ id, placeholder }}
										/>
									</BaseControl>
								</td>
								<td>
									<div className="wecodeart-button-group">
										{externalUrl !== '' &&
											<ExternalLink href={externalUrl} className="wecodeart-button-group__item">
												{__('More info', 'wca-google')}
											</ExternalLink>
										}
									</div>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
			<p>
				<Button
					className="button"
					isPrimary
					isLarge
					icon={loading && <Spinner />}
					onClick={() => {
						setLoading(true);
						let value = {};
						Object.keys(formData).map(k => value = { ...value, [k]: formData[k] === '' ? 'unset' : formData[k] });
						saveEntityRecord('wecodeart', 'settings', value).then(handleNotice);
					}}
				>
					{loading ? '' : __('Save', 'wca-google')}
				</Button>
			</p>
		</>
	);
};